<template lang="pug">
  .faceSaaS
    top-informations(title="人脸识别" subtitle="让万物更智能，让世界更安全" text="Easier lift safer world")
    project-design(text="人脸识别解决方案基于AIoT底层框架，提供从本地模型预测、边缘端模型推理、云端模型推理的三位一体化解决方案\nAI OPS训练产生的模型，通过IoT OPS动态下发到终端，实现终端模型的动态更新。目前在数字教育行业人脸识别门禁场景较为典型。")
    framework(:framework="framework")
    product-and-server(:products="products")
    scene(:scenes="['数字城市', '数字教育']")
</template>

<script>
  import TopTitle from "@/components/topTitle";
  import TopInformations from "@/views/Solution/components/TopInformations/TopInformations";
  import ProjectDesign from "@/views/Solution/components/ProjectDesign/ProjectDesign";
  import Framework from "@/views/Solution/components/Framework/Framework";
  import ProductAndServer from "@/views/Solution/components/ProductAndServer/ProductAndServer";
  import Scene from "@/views/Solution/components/Scene/Scene";
  // import framework from '@/assets/images/实现架构内容.png'
  const framework = 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E6%9E%B6%E6%9E%84%E5%9B%BE/%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-%E4%BA%BA%E8%84%B8%E8%AF%86%E5%88%AB-%E6%9E%B6%E6%9E%84%E5%9B%BE.png'

  import 核心技术 from '@/assets/images/前沿的核心技术.png'
  import 产品功能 from '@/assets/images/产品功能.png'
  import 接入方案 from '@/assets/images/多类别接入方案.png'
  export default {
    name: "faceSaaS",
    components: {Scene, ProductAndServer, Framework, ProjectDesign, TopInformations, TopTitle},
    data() {
      return {
        framework,
        products: [
          {
            img: 核心技术,
            title: '前沿的核心技术',
            texts: ['终端、边缘、云端三位一体的联合推理能力', '终端和边缘模型的智能下发能力', 'IoT OPS和AI OPS的深度联动，赋能终端智能化能力'],
          },
          {
            img: 产品功能,
            title: '产品功能',
            texts: ['人脸检测', '人脸比对', '人脸搜索'],
          },
          {
            img: 接入方案,
            title: '多类别接入方案',
            texts: ['多终端可接入web、mobile', '个性化定制SDK\n边缘端人脸识别SDK\n云边端一体化识别SDK\n云端人脸识别SDK、终端人脸识别SDK'],
          },
        ]
      }
    },
  };
</script>

<style scoped lang="stylus">
  .faceSaaS {
    background-color white
  }
</style>
